import React from "react";
import { useQuery } from "@tanstack/react-query";
import { getStoreCollections } from './../../../apis/requests';
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import useLang from "../../../hooks/useLang";
import CollectionsLoader from './CollectionsLoader';
const ShopByCollections = () => {
    const { t } = useTranslation();
    const lang = useLang();
    const { data, isLoading } = useQuery({
        queryKey: ["getStoreCollections"],
        refetchOnWindowFocus: false,
        refetchOnReconnect: false,
        refetchOnMount: false,
        queryFn: () => {
            return getStoreCollections();
        },
    });
    const collections = data?.data.collections || [];

    return (
        <div>
            <div className="p-6 lg:py-4 py-6 my-4">
                <div className="text-center">
                    <h1 className="text-4xl font-semibold text-[#004040]">Collections</h1>
                    <h2 className="text-xl font-medium py-2">Explore curated collections handpicked for you</h2>
                </div>
            </div>
            <div className="mx-4 mb-5">
                {
                    isLoading &&
                    <CollectionsLoader />
                }
                <div className="grid grid-cols-1 sm:grid-cols-1 md:grid-cols-3 lg:grid-cols-3 gap-4">
                    {
                        !isLoading &&
                        collections.map((collection) => {
                            return (
                                <div key={collection.id}>
                                    <Link
                                        to={"/shop/collection/" + collection.id + "/" + (lang === "en" ? collection.name : collection.name_ar)}
                                    >
                                        <img
                                            className="rounded-xl"
                                            loading="lazy"
                                            src={collection.image}
                                            alt={collection.name}
                                        />
                                        <div className="flex items-center gap-2 my-2 text-[#004040]">
                                            <span className="font-semibold text-[#004040]">{lang === "en" ? collection.name : collection.name_ar}</span>
                                            <span className="material-symbols-outlined">
                                                {lang === "en" ? "arrow_right_alt" : "arrow_left_alt"}
                                            </span>
                                        </div>
                                    </Link>
                                    <div className="flex items-center">
                                        <span className="material-symbols-outlined">
                                            local_mall
                                        </span>
                                        <span className="font-semibold text-sm mt-1">{JSON.parse(collection.products).length} {t('products')}</span>
                                    </div>
                                </div>
                            );
                        })
                    }
                </div>
            </div>
        </div>
    );
}

export default ShopByCollections;